import React from 'react';

import InfoLink from '../InfoLink';

import './style.scss';

const ImageCard = ({ linktext, href, description, src, alt, width }) => {
	return (
		<div className="image-card" style={{ width: width }}>
			<img className="image-card-image" src={src} alt={alt}></img>
			<div className="image-card-link">
				<InfoLink href={href}>{linktext}</InfoLink>
			</div>
			<div className="image-card-description">{description}</div>
		</div>
	);
};

export default ImageCard;
